import { customVoiceLicenseManager } from "@/services/license/license-managers/custom-voices-license-manager";

export interface PricingFeatureBase {
  name: string;
}

export interface TrainingPricingFeature extends PricingFeatureBase {
  voices: string;
  quality: string;
  retries: string;
  vocalCleanup: string;
  trainingSpeed: string;
  datasetLength: string;
}

export interface GenerationPricingFeature extends PricingFeatureBase {
  voiceCloning: string;
  conversionSpeed: string;
  resultDuration: string;
  removeInstrumentals: string;
  accessToAllVoices: string;
  enhanceVocals: string;
  advancedConversionSettings: string;
  aiMastering: string;
  convertHistory: string;
  textToSpeech: string;
  vocalRemover: string;
  deEchoAndDeReverb: string;
  stemSplitter: string;
  duets: string;
  beatMachine: string;
}

export interface PricingFeaturesTableProps<T extends PricingFeatureBase> {
  title: string;
  featuresData: T[];
  featureMap: { [p: string]: keyof T };
}
const customVoiceCountLimiter =
  customVoiceLicenseManager.serviceUsingCountLimiter;

const customVoiceDurationLimiter =
  customVoiceLicenseManager.datasetDurationLimiter;

export const trainingFeaturesData = [
  {
    name: "Trial",
    voices: `${customVoiceCountLimiter.getPlanLimit("Trial")}`,
    quality: "Standard",
    retries: "x",
    vocalCleanup: "x",
    trainingSpeed: "Slow",
    datasetLength: `${customVoiceDurationLimiter.getPlanLimit("Trial")} Minutes`,
  },
  {
    name: "Starter",
    voices: `${customVoiceCountLimiter.getPlanLimit("Starter")}`,
    quality: "High-Fidelity",
    retries: "Unlimited",
    vocalCleanup: "x",
    trainingSpeed: "Standard",
    datasetLength: `${customVoiceDurationLimiter.getPlanLimit("Starter")} Minutes`,
  },
  {
    name: "Creator",
    voices: `${customVoiceCountLimiter.getPlanLimit("Creator")}`,
    quality: "High-Fidelity",
    retries: "Unlimited",
    vocalCleanup: "✓",
    trainingSpeed: "Standard",
    datasetLength: `${customVoiceDurationLimiter.getPlanLimit("Creator")} Minutes`,
  },
  {
    name: "Studio",
    voices: `${customVoiceCountLimiter.getPlanLimit("Studio")}`,
    quality: "High-Fidelity",
    retries: "Unlimited",
    vocalCleanup: "✓",
    trainingSpeed: "Fastest",
    datasetLength: `${customVoiceDurationLimiter.getPlanLimit("Studio")} Minutes`,
  },
] as TrainingPricingFeature[];

export const trainingFeatureMap: {
  [key: string]: keyof TrainingPricingFeature;
} = {
  Voices: "voices",
  Quality: "quality",
  Retries: "retries",
  "Vocal Cleanup": "vocalCleanup",
  "Training Speed": "trainingSpeed",
  "Dataset Length": "datasetLength",
};

export const generationsFeatureMap: {
  [key: string]: keyof GenerationPricingFeature;
} = {
  //"Voice Cloning": "voiceCloning",
  "Generation Speed": "conversionSpeed",
  "Result Duration": "resultDuration",
  "Remove Instrumentals": "removeInstrumentals",
  // "Access to All Voices": "accessToAllVoices",
  "Enhance Vocals": "enhanceVocals",
  // "Advanced conversion settings": "advancedConversionSettings",
  "AI mastering": "aiMastering",
  // "Convert history": "convertHistory",
  "Text-to-speech": "textToSpeech",
  "Vocal Remover": "vocalRemover",
  "De-echo & De-reverb": "deEchoAndDeReverb",
  "Stem splitter": "stemSplitter",
  // Duets: "duets",
  // "Beat machine": "beatMachine",
};

export const generationsFeaturesData = [
  {
    name: "Trial",
    // voiceCloning: "3",
    conversionSpeed: "Standard",
    resultDuration: "15 seconds",
    removeInstrumentals: "✓",
    // accessToAllVoices: "x",
    enhanceVocals: "x",
    // advancedConversionSettings: "✓",
    aiMastering: "✓",
    // convertHistory: "✓",
    textToSpeech: "x",
    vocalRemover: "✓",
    deEchoAndDeReverb: "✓",
    stemSplitter: "✓",
    // duets: "x",
    // beatMachine: "x",
  },
  {
    name: "Starter",
    // voiceCloning: "500",
    conversionSpeed: "Fast",
    resultDuration: "Unlimited",
    removeInstrumentals: "✓",
    // accessToAllVoices: "✓",
    enhanceVocals: "✓",
    // advancedConversionSettings: "✓",
    aiMastering: "x",
    // convertHistory: "✓",
    textToSpeech: "✓",
    vocalRemover: "✓",
    deEchoAndDeReverb: "✓",
    stemSplitter: "✓",
    // duets: "x",
    // beatMachine: "x",
  },
  {
    name: "Creator",
    // voiceCloning: "1000",
    conversionSpeed: "Fast",
    resultDuration: "Unlimited",
    removeInstrumentals: "✓",
    // accessToAllVoices: "✓",
    enhanceVocals: "✓",
    // advancedConversionSettings: "✓",
    aiMastering: "x",
    // convertHistory: "✓",
    textToSpeech: "✓",
    vocalRemover: "✓",
    deEchoAndDeReverb: "✓",
    stemSplitter: "✓",
    // duets: "✓",
    // beatMachine: "✓",
  },
  {
    name: "Studio",
    // voiceCloning: "Unlimited",
    conversionSpeed: "Fastest",
    resultDuration: "Unlimited",
    removeInstrumentals: "✓",
    // accessToAllVoices: "✓",
    enhanceVocals: "✓",
    // advancedConversionSettings: "✓",
    aiMastering: "✓",
    // convertHistory: "✓",
    textToSpeech: "✓",
    vocalRemover: "✓",
    deEchoAndDeReverb: "✓",
    stemSplitter: "✓",
    // duets: "✓",
    // beatMachine: "✓",
  },
] as GenerationPricingFeature[];
